import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { merge } from 'lodash-es';
import { NgIf } from '@angular/common';
import { ConfirmDialogData } from '../../type/dialog.type';
import { GenericDialogDirective } from '../generic-dialog.directive';

@Component({
  selector: 'portal-ui-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule, NgIf],
  templateUrl: './confirm-dialog.component.html',
  styles: [
    `
      :host {
        @apply block min-w-64;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent extends GenericDialogDirective {
  protected readonly dialog: MatDialogRef<ConfirmDialogComponent, boolean> = inject(MatDialogRef<ConfirmDialogComponent, boolean>);
  protected readonly config: ConfirmDialogData = merge<ConfirmDialogData, ConfirmDialogData>(
    { title: 'Confirmation', button: { cancel: { label: 'Cancel' }, confirm: { label: 'Confirm' } } },
    inject<ConfirmDialogData>(MAT_DIALOG_DATA),
  );
}
